<div class="fixed-top">
  <nav class="navbar navbar-expand-lg navbar-light themeColor" id="navbar">
    <div class="container pr-0">
      <a class="navbar-brand">
        <span (click)="toggleSideBar()" style="cursor: pointer;">
          <i class="fa fa-bars" aria-hidden="true" style="color: #022c67;"></i>
        </span>
        <span style="outline-style: none; box-shadow: none; border-color: transparent;" routerLink="huzaifaanjum"
          onclick="window.scroll(0,0);" class="nameStyle">
          <span>Huzaifa Anjum</span>
        </span>
      </a>
      <button class="navbar-toggler" style="display: none;" type="button" data-toggle="collapse"
        data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end themeColor" id="navbarCollapse">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="#about" onclick="event.preventDefault();"
              (click)="scrollToSection('about')">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#skills" onclick="event.preventDefault();"
              (click)="scrollToSection('skills')">Technologies</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#experience" onclick="event.preventDefault();"
              (click)="scrollToSection('experience')">Experience</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#projects" onclick="event.preventDefault();"
              (click)="scrollToSection('projects')">Projects</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#certificates" onclick="event.preventDefault();"
              (click)="scrollToSection('certificates')">Certificates</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#interests" onclick="event.preventDefault();"
              (click)="scrollToSection('interests')">Interests</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#contact" onclick="event.preventDefault();"
              (click)="scrollToSection('contact')">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="progress-container">
    <div class="progress-bar" id="scrollBar"></div>
  </div>
</div>

<div class="p-4"></div>
